<script>
export default {
  name: 'ChartSeriesGuide',
  props: {
    series: {
      type: Array,
      default: () => [],
      validator(series) {
        return series.every(s => s.name && s.color);
      },
    },
    align: {
      type: String,
      default: 'center',
      validator(align) {
        return ['center', 'left', 'right'].includes(align);
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSeriesItemClick(seriesItem, index) {
      if (this.readonly) return;
      this.$emit('select', seriesItem, index);
    },
  },
};
</script>

<template>
  <div
    class="chart-series-guide"
    :class="{ 'chart-series-guide--readonly': readonly }"
    :style="{ justifyContent: align }"
  >
    <div
      v-for="(seriesItem, index) in series"
      :key="seriesItem.name"
      class="chart-series-guide__item"
      @click="handleSeriesItemClick(seriesItem, index)"
    >
      <div
        class="chart-series-guide__color"
        :style="`background-color: ${seriesItem.color};`"
      />

      <div>
        {{ seriesItem.name }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.chart-series-guide {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 80%;
  cursor: pointer;

  &--readonly {
    cursor: default;
  }

  &__item {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 0.4rem;
    line-height: normal;

    @include rtl() {
      flex-direction: row;
    }
  }

  &__color {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
  }
}
</style>
